import Chip from "@mui/material/Chip";
import * as React from "react";
import Box from '@mui/system/Box';
import Container from '@mui/material/Container';

export default function ChipUser({userName,userLevel})
{
    function chipClicked(ev){
        window.location = '/registro';
    }
    //sx={{display:'inline-flex',alignItems:'center',background:'blue',width:'100%'}}
    return(
        <Container style={{display:'flex',widht:'100%',alignItems:'flex-end'}}>
            <Chip label={userName} id={'chipUID'}
                sx={{mr:1,background:'darkOliveGreen' ,color:'lawnGreen',fontSize:'0.9em'}}/>
            <Chip label={userLevel} id={'chipLevel'}
                sx={{background:'darkOliveGreen' ,color:'lawnGreen',fontSize:'0.9em'}}/>
        </Container>
    )
}